jQuery(document).ready(function ($) {

    const range = document.getElementById('range');
    const rangeV = document.getElementById('rangeV');
    const rangeBottom = document.getElementById('rangeBottom');
    const rangeBottomV = document.getElementById('rangeBottomV');

    setValue = () => {
        var sliderVal = $("#range").val();
        $(".val").text("£" + sliderVal * 10);
        const
            newValue = Number((range.value - range.min) * 100 / (range.max - range.min)),
            newPosition = 10 - (newValue * 0.17);
        rangeV.innerHTML = `<span>${range.value}</span>`;
        $('#rangeBottomV').html(`<span>${range.value}</span>`);
        $('#form_postcode').val(range.value);
        rangeV.style.left = `calc(${newValue}% + (${newPosition}px))`;

        if ($('#rangeBottom').val() != range.value) {
            $('#rangeBottom').val(range.value);
            setValueBottom();
        }
    };






    setValueBottom = () => {
        const
            newValue = Number((rangeBottom.value - rangeBottom.min) * 100 / (rangeBottom.max - rangeBottom.min)),
            newPosition = 10 - (newValue * 0.17);
        rangeBottomV.innerHTML = `<span>${rangeBottom.value}</span>`;
        rangeBottomV.style.left = `calc(${newValue}% + (${newPosition}px))`;
        $('#rangeV').html(`<span>${rangeBottom.value}</span>`);

        if ($('#range').val() != rangeBottom.value) {
            $('#range').val(rangeBottom.value);
            setValue();
        }

    };
    range.addEventListener('input', setValue);
    rangeBottom.addEventListener('input', setValueBottom);
    setValueBottom();
    setValue();
});